import { useSelector } from "react-redux";
import DefaultLayout from "../components/layout/DefaultLayout";
import ListProperties from "../components/properties/ListProperties";

function Properties() {
  const selectedRentBuy = useSelector((state) => state.ui.selectedRentBuy);
  const selectedPlace = useSelector((state) => state.ui.selectedPlace);
  const selectedPropertyType = useSelector(
    (state) => state.ui.selectedPropertyType
  );
  const rentSlider = useSelector((state) => state.ui.rentSlider);
  const buySlider = useSelector((state) => state.ui.buySlider);

  const filters = {
    offerType: selectedRentBuy,
    cityName: selectedPlace,
    property_type: selectedPropertyType,
    rentMin: rentSlider.minValue,
    rentMax: rentSlider.maxValue,
    buyMin: buySlider.minValue,
    buyMax: buySlider.maxValue,
  };
  const body = () => {
    return <ListProperties bussines="" filters={filters} />;
  };
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default Properties;
